import {
  Checkbox,
  UpdateIconButton,
  formatBoolean,
  ListMenu,
  
  pn,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@compass/core";

import { ListBeProperty } from "components";
import {
  Permission,
  PermissionAction,
  SortObject,
  StudentGroupListDto,
  StudentGroupListResource,
} from "generated/openApi";

import { useNavigate } from "react-router-dom";
import { isAuthorized } from "services";
import { studentGroupPageRoute } from "../StudentGroupPage/StudentGroupPage";
import { useStudentGroupListMenuItems } from "./useStudentGroupListMenuItems";

export const StudentGroupTable = (props: {
  rootPermission: Permission;
  tableContainerRef: React.RefObject<HTMLDivElement>;
  studentGroups: StudentGroupListDto[];
  listTotal: number | undefined;
  resource: StudentGroupListResource;
  searchFocused: boolean;
  sortObjects: SortObject[] | undefined;
  sort: (sortObjects: SortObject[]) => void;
  selectId: (id: number) => void;
  selectedIds: number[];
  setSelectedIds: React.Dispatch<React.SetStateAction<number[]>>;
  getIdsPromise: () => Promise<any>;
}) => {
  const navigate = useNavigate();
  const properties = props.resource.properties || [];
  const menuItems = useStudentGroupListMenuItems({ permission: props.rootPermission });

  return (
    <TableContainer ref={props.tableContainerRef}>
      <Table stickyHeader>
        <TableHead>
          <TableRow>
            {menuItems.length > 0 && (
              <TableCell type="select">
                <ListMenu
                  selectedIds={props.selectedIds}
                  setSelectedIds={props.setSelectedIds}
                  listTotal={props.listTotal}
                  fetchFunction={() => props.getIdsPromise()}
                  actionMenuItems={menuItems}
                />
              </TableCell>
            )}

            <TableCell>
              <ListBeProperty
                listProperty={properties.find((x) => x.propertyName === pn<StudentGroupListDto>("name"))}
                sortObjects={props.sortObjects}
                onChange={(sortObjects) => props.sort(sortObjects)}
                searchFocused={props.searchFocused}
              />
            </TableCell>

            <TableCell>
              <ListBeProperty
                listProperty={properties.find((x) => x.propertyName === pn<StudentGroupListDto>("school"))}
                sortObjects={props.sortObjects}
                onChange={(sortObjects) => props.sort(sortObjects)}
                searchFocused={props.searchFocused}
              />
            </TableCell>

            <TableCell>
              <ListBeProperty
                listProperty={properties.find((x) => x.propertyName === pn<StudentGroupListDto>("assignedStudents"))}
                sortObjects={props.sortObjects}
                onChange={(sortObjects) => props.sort(sortObjects)}
                searchFocused={props.searchFocused}
              />
            </TableCell>
            <TableCell>
              <ListBeProperty
                listProperty={properties.find((x) => x.propertyName === pn<StudentGroupListDto>("inactive"))}
                sortObjects={props.sortObjects}
                onChange={(sortObjects) => props.sort(sortObjects)}
                searchFocused={props.searchFocused}
              />
            </TableCell>

            <TableCell></TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {props.studentGroups.map((studentGroupItem) => (
            <TableRow
              key={studentGroupItem.id}
              onClick={() =>
                navigate({
                  pathname: studentGroupPageRoute.getPath({ id: studentGroupItem.id, crudMode: "view" }),
                })
              }
            >
              {menuItems.length > 0 && (
                <TableCell type="select">
                  <Checkbox
                    checked={props.selectedIds.includes(studentGroupItem.id)}
                    onClick={(e) => props.selectId(studentGroupItem.id)}
                  />
                </TableCell>
              )}
              <TableCell>{studentGroupItem.name}</TableCell>
              <TableCell>{studentGroupItem.school}</TableCell>
              <TableCell>{studentGroupItem.assignedStudents}</TableCell>
              <TableCell>{formatBoolean(studentGroupItem.inactive)}</TableCell>
              <TableCell type="action">
                {isAuthorized(props.rootPermission, PermissionAction.Update) && (
                  <UpdateIconButton color="primary"
                    onClick={() =>
                      navigate({
                        pathname: studentGroupPageRoute.getPath({
                          id: studentGroupItem.id,
                          crudMode: "edit",
                        }),
                      })
                    }
                  />
                )}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};
